export const PATH = {
  POINTS: '/points',
  REWARDS: '/rewards',
  RESOURCES: '/resources',
  SETTINGS: '/settings'
};

export const DEADLINE_RESEND = 30;
